module.exports = __webpack_public_path__ + "static/img/team-build-2.7b07eb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/team-build-2.png
// module id = 2tfD
// module chunks = 1